import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=423fda8d&scoped=true&"
import script from "./VerifyPhone.vue?vue&type=script&lang=js&"
export * from "./VerifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VerifyPhone.vue?vue&type=style&index=1&id=423fda8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423fda8d",
  null
  
)

export default component.exports